import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HeaderComponent, NavigationModule } from '@fcom/common/components';
import { BaseLayoutComponent, BaseLayoutModule } from '@fcom/common/components/base-layout';
import { CmsModule, CmsFooterComponent } from '@fcom/cms/components';
import { OndMarketingRoutesPath } from '@fcom/ond-marketing-landing-core';

import { OndMarketingLandingComponent } from './components/ond-marketing-landing.component';
import { OndMarketingLandingViewPageGuard } from './services/ond-marketing-landing-view-page.guard';
import { OndMarketingListingComponent } from './components/ond-marketing-listing.component';

export const ondMarketingLandingRoutes: Routes = [
  {
    path: '',
    component: BaseLayoutComponent,
    children: [
      { path: '', component: HeaderComponent, outlet: 'header' },
      {
        path: `${OndMarketingRoutesPath.CITY_TO_CITY}`,
        component: OndMarketingListingComponent,
        data: { key: 'cityToCity' },
      },
      {
        path: `${OndMarketingRoutesPath.CITY_TO_CITY}/:originLocationCode/:destinationLocationCode`,
        component: OndMarketingLandingComponent,
        canActivate: [OndMarketingLandingViewPageGuard],
      },
      {
        path: `${OndMarketingRoutesPath.CITY_TO_CITY}/:originLocationCode/:destinationLocationCode/:ignoredSEOTitle`,
        component: OndMarketingLandingComponent,
        canActivate: [OndMarketingLandingViewPageGuard],
      },
      {
        path: `${OndMarketingRoutesPath.COUNTRY_TO_COUNTRY}`,
        component: OndMarketingListingComponent,
        data: { key: 'countryToCountry' },
      },
      {
        path: `${OndMarketingRoutesPath.COUNTRY_TO_COUNTRY}/:originLocationCode/:destinationLocationCode`,
        component: OndMarketingLandingComponent,
        canActivate: [OndMarketingLandingViewPageGuard],
      },
      {
        path: `${OndMarketingRoutesPath.COUNTRY_TO_COUNTRY}/:originLocationCode/:destinationLocationCode/:ignoredSEOTitle`,
        component: OndMarketingLandingComponent,
        canActivate: [OndMarketingLandingViewPageGuard],
      },
      {
        path: `${OndMarketingRoutesPath.FROM_COUNTRY}`,
        component: OndMarketingListingComponent,
        data: { key: 'fromCountry' },
      },
      {
        path: `${OndMarketingRoutesPath.FROM_COUNTRY}/:originLocationCode`,
        component: OndMarketingLandingComponent,
        canActivate: [OndMarketingLandingViewPageGuard],
      },
      {
        path: `${OndMarketingRoutesPath.FROM_COUNTRY}/:originLocationCode/:ignoredSEOTitle`,
        component: OndMarketingLandingComponent,
        canActivate: [OndMarketingLandingViewPageGuard],
      },
      {
        path: `${OndMarketingRoutesPath.FROM}`,
        component: OndMarketingListingComponent,
        data: { key: 'from' },
      },
      {
        path: `${OndMarketingRoutesPath.FROM}/:originLocationCode`,
        component: OndMarketingLandingComponent,
        canActivate: [OndMarketingLandingViewPageGuard],
      },
      {
        path: `${OndMarketingRoutesPath.FROM}/:originLocationCode/:ignoredSEOTitle`,
        component: OndMarketingLandingComponent,
        canActivate: [OndMarketingLandingViewPageGuard],
      },
      { path: '', component: CmsFooterComponent, outlet: 'footer' },
    ],
  },
];

@NgModule({
  imports: [NavigationModule, BaseLayoutModule, CmsModule, RouterModule.forChild(ondMarketingLandingRoutes)],
  declarations: [],
  providers: [OndMarketingLandingViewPageGuard],
  exports: [RouterModule],
})
export class OndMarketingLandingRouteModule {}
